import { ActionType } from 'api/betslipAnalytics.api';
import TrashIcon from 'assets/images/actions/trashIcon.svg?react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useBetslipAnalytics } from 'shared/hooks/useBetslipAnalytics';
import { CouponState, State } from 'shared/interface/index';

import './styles.scss';

interface CouponRemoveAllButtonProps {
	removeAllBets: (coupon: any) => void;
}

const CouponRemoveAllButton = ({ removeAllBets }: CouponRemoveAllButtonProps) => {
	const history = useHistory();
	const { addAction } = useBetslipAnalytics();
	const coupon = useSelector<State, CouponState>((state) => state.coupon);

	const handleClick = () => {
		removeAllBets(coupon);
		coupon.bets.outcomes.forEach((item: any) => {
			addAction(item, `${history.location.pathname}/${history.location?.hash}`, ActionType.REMOVE);
		});
	};

	return (
		<div className="CouponRemoveAllButton" data-cy="betslip-trash" onClick={handleClick}>
			<TrashIcon />
		</div>
	);
};

export default CouponRemoveAllButton;
